<script>
  import { onMount, afterUpdate, onDestroy } from "svelte";

  export let tableData = undefined;
  export let specData = undefined;
  export let sequenceData = undefined;

  let firstColumnWidth = 0;
  let firstColumnRef;

  function GetColor(val) {
    const colors = ["zero", "one", "two", "three", "four", "five"];
    return val == -1 ? "zero" : colors[Math.min(Math.floor(val * 5) + 1, 5)];
  }

  function updateColumnWidth() {
    if (firstColumnRef) {
      firstColumnWidth = firstColumnRef.getBoundingClientRect().width;
    }
  }

  onMount(() => {
    updateColumnWidth();
    window.addEventListener("resize", updateColumnWidth);
  });

  afterUpdate(() => {
    updateColumnWidth();
  });

  onDestroy(() => {
    window.removeEventListener("resize", updateColumnWidth);
  });
</script>

{#if tableData}
  <table class="sticky-table">
    <tbody>
      <tr>
        <td class="sticky-col first-col bordered" colspan="2">仕様/投入順</td>
        {#each Array.from({ length: tableData[0].length }, (_, i) => i + 1) as i}
          <td class="bordered" style="background-color: #f0f0f0">{i % 10 === 0 ? i : ""}</td>
        {/each}
      </tr>
      {#each tableData as row, idx}
        <tr>
          {#if Array.isArray(specData[idx].DisplayString)}
            <td class="sticky-col first-col" bind:this={firstColumnRef}>
              {specData[idx].DisplayString[0]}
            </td>
            <td
              class="sticky-col second-col"
              style="--first-col-width: {firstColumnWidth}px;"
            >
              {specData[idx].DisplayString[1]}
            </td>
          {:else}
            <td
              class="sticky-col first-col"
              colspan="2"
              bind:this={firstColumnRef}
            >
              {specData[idx].DisplayString}
            </td>
          {/if}
          {#each row as _, colIndex}
            <td class="bordered {GetColor(sequenceData[idx][colIndex + 1])}" />
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<style>
  .sticky-table {
    border-collapse: collapse;
    max-width: 100%;
    overflow-x: auto;
  }

  .sticky-table td {
    padding: 8px;
    text-align: center;
    white-space: nowrap;
    min-width: 30px;
  }

  .sticky-col {
    border: none;
    position: sticky;
    background-color: #f0f0f0;
    border-collapse: separate;
    margin-left: -3px;
  }
  .bordered {
    border: 1px solid #ddd;
  }

  .first-col {
    left: 0;
  }

  .second-col {
    left: var(--first-col-width);
  }

  .zero {
    background-color: white;
  }
  .one {
    background-color: #4dbaa8;
  }
  .two {
    background-color: #6edaab;
  }
  .three {
    background-color: #fce65d;
  }
  .four {
    background-color: #ffb729;
  }
  .five {
    background-color: #fb5236;
  }
</style>
